import './index.css'
import '@surein/ui/styles/index.css'
import './sentry'

import { SidebarProvider, TooltipProvider } from '@surein/ui'
import { StrictMode, Suspense } from 'react'
import { CookiesProvider } from 'react-cookie'
import ReactDOM from 'react-dom/client'
import { RouterProvider } from 'react-router-dom'
import { Loader } from './components'
import './i18n/init'
import {
  AuthProvider,
  ReactQueryProvider,
  SnackbarProvider,
  ThemeProvider,
} from './providers'
import { ContactModalProvider } from './providers/ContactModalProvider'
import { router } from './routes'
import { ABTestProvider } from './modules/ABTest/ABTestContext'
import { composeProviders } from './providers/ProviderAccumulator'

const providers = [
  { component: StrictMode },
  { component: ThemeProvider },
  {
    component: ({ children }: { children: React.ReactNode }) => (
      <Suspense fallback={<Loader />}>{children}</Suspense>
    ),
  },
  { component: ContactModalProvider },
  { component: CookiesProvider },
  { component: ABTestProvider },
  { component: SnackbarProvider },
  { component: TooltipProvider, props: { delayDuration: 150 } },
  { component: SidebarProvider, props: { style: { flexDirection: 'column' } } },
  { component: AuthProvider },
  { component: ReactQueryProvider },
]

const ComposedProviders = composeProviders(providers)

ReactDOM.createRoot(document.getElementById('root')!).render(
  <ComposedProviders>
    <RouterProvider router={router} />
  </ComposedProviders>,
)
